import React, { ReactElement, FunctionComponent, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Touchable from '@sport1/react-elements/Touchable'
import Indicator from '../../BaseComponents/ProgressBar/ProgressIndicator'
import Divider from '../../BaseComponents/Divider'
import { TestID } from '../../utils/PropTypesDefinitions'
import Likes from './Likes'
import Paging from './Paging'

export type BottomToolbarProps = {
    text: string
    numberOfLikes?: number
    indicatorPercent?: number
    onLike?: () => void
    onShare?: () => void
    onNext: () => void
} & TestID

const BottomToolbar: FunctionComponent<BottomToolbarProps> = ({
    text,
    numberOfLikes = 0,
    indicatorPercent,
    onLike,
    onShare,
    onNext,
    testID,
}): ReactElement => {
    return (
        <Grid noExpand testID={testID}>
            {indicatorPercent !== undefined && indicatorPercent >= 0 ? (
                <Indicator indicatorPercent={indicatorPercent} />
            ) : (
                <Divider dark />
            )}
            <Grid
                noExpand
                backgroundColor="pearl"
                horizontal
                centerVertical
                height={48}
                paddingX={5}
            >
                {onLike ? (
                    <Grid noExpand marginRight={5}>
                        <Likes onLike={onLike} numberOfLikes={numberOfLikes} color="onyx" />
                    </Grid>
                ) : null}
                <Grid marginRight={5}>
                    {onShare ? (
                        <Touchable onPress={onShare}>
                            <FontelloIcon name="share-android" color="onyx" fontSize={17} />
                        </Touchable>
                    ) : null}
                </Grid>
                <Paging onNext={onNext} color="onyx" text={text} />
            </Grid>
        </Grid>
    )
}

export default memo(BottomToolbar)
